export default __webpack_public_path__ + "static/media/mobile-project-2.a5aae786.jpg";